import type { ConstructorCollection } from '@Types/Constructor';
import type { OrderFabricsData } from '../typings';

function collectCollections(data: OrderFabricsData): ConstructorCollection[] {
  // Формируем коллекции тканей
  const collectionsMap = {};
  data.parameterValues
    .filter((p) => p.type === 'fabric')
    // Оставляем только ткани, которые являются товарами-образцами
    .filter((p) => !!p.sampleId)
    .forEach((fabric) => {
      const { collectionId } = fabric.tags;

      if (collectionsMap[collectionId]) {
        if (fabric.price < collectionsMap[collectionId].minPrice) {
          collectionsMap[collectionId].minPrice = fabric.price;
        }

        collectionsMap[collectionId].fabrics.push(fabric);
      } else {
        collectionsMap[collectionId] = {
          ...data.tags.collections[collectionId],
          minPrice: fabric.price,
          fabrics: [fabric],
        };
      }
    });

  return Object.values(collectionsMap);
}

export default collectCollections;
